import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import Spinner from '../layout/Spinner';

const Navbar = ({ auth: { user, isAuthenticated, loading }, logout }) => {
  const guestLinks = (
    <ul className="navbar-nav">
      {/* <li className="nav-item">
        <Link className="nav-link" to="/articles">
          Articles
        </Link>
      </li> */}
      <li className="nav-item">
        <Link className="nav-link" to="/register">
          Register
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/login">
          Login
        </Link>
      </li>
    </ul>
  );

  return loading && user !== null ? (
    <Spinner />
  ) : (
    <Fragment>
      {user !== null ? (
        <Fragment>
          <nav className="navbar navbar-expand-lg navbar-light sticky-top shadow-sm">
            <div className="container">
              <Link className="navbar-brand logo-style" to="/posts">
                U<span className="">i.school</span>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#authNavbar"
                aria-controls="authNavbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse justify-content-md-end"
                id="authNavbar"
                data-toggle="collapse"
                data-target=".show#authNavbar"
              >
                {!loading && (
                  <Fragment>
                    {' '}
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <Link className="nav-link" to="/posts">
                          Home
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to={`/profile/${user._id}`}>
                          My Profile
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/profiles">
                          Users
                        </Link>
                      </li>
                      {/* <li className="nav-item">
                        <Link className="nav-link" to="/dashboard">
                          <span className="hide-sm">Dashboard</span>
                        </Link>
                      </li> */}
                      <li className="nav-item">
                        <a onClick={logout} className="nav-link" href="#!">
                          Logout
                          {/* <i className="fas fa-sign-out-alt" /> */}
                        </a>
                      </li>
                    </ul>
                  </Fragment>
                )}
              </div>
            </div>
          </nav>
        </Fragment>
      ) : (
        <Fragment>
          <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
            <div className="container">
              <Link className="navbar-brand logo-style" to="/">
                U<span className="">i.school</span>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse justify-content-md-end"
                id="navbarNav"
                data-toggle="collapse"
                data-target=".show#navbarNav"
              >
                {<Fragment>{guestLinks}</Fragment>}
              </div>
            </div>
          </nav>
        </Fragment>
      )}
    </Fragment>
  );
};

// add to the prop types
Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

// pulls in all the state that is in the auth reducer
const mapStateToProps = (state) => ({
  auth: state.auth
});

// logout is the action
export default connect(mapStateToProps, { logout })(Navbar);
